// TODO: Not sure if still needed
export enum ChallengeId {
  TRACK_UPLOADS = 'u',
  REFERRALS = 'r',
  VERIFIED_REFERRALS = 'rv',
  REFERRED = 'rd',
  MOBILE_INSTALL = 'm',
  CONNECT_VERIFIED_ACCOUNT = 'v',
  LISTEN_STREAK_ENDLESS = 'e',
  COMPLETE_PROFILE = 'p',
  SEND_FIRST_TIP = 'ft',
  CREATE_FIRST_PLAYLIST = 'fp',
  AUDIO_MATCHING_BUYER = 'b',
  AUDIO_MATCHING_SELLER = 's',
  TRENDING_TRACK = 'tt',
  TRENDING_PLAYLIST = 'tp',
  TRENDING_UNDERGROUND_TRACK = 'tut',
  ONE_SHOT = 'o',
  FIRST_WEEKLY_COMMENT = 'c',
  PLAY_COUNT_250_MILESTONE_2025 = 'p1',
  PLAY_COUNT_1000_MILESTONE_2025 = 'p2',
  PLAY_COUNT_10000_MILESTONE_2025 = 'p3',
  TASTEMAKER = 't',
  COSIGN = 'cs',
  PINNED_COMMENT = 'cp',
  REMIX_CONTEST_WINNER = 'w'
}
